import script from "./CardGestionInfoTorneoEquipo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardGestionInfoTorneoEquipo.vue?vue&type=script&setup=true&lang=ts"

import "./CardGestionInfoTorneoEquipo.vue?vue&type=style&index=0&id=3938af53&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3938af53"]])

export default __exports__